import displayErrorToast from '@shared/helpers/displayErrorToast';

import { SocialAuthButtonProps } from '../AuthModal';
import useGoogleOAuthClient from '../useGoogleOAuthClient';

const GoogleAuthButton = ({ className, disabled, children }: SocialAuthButtonProps) => {
  const client = useGoogleOAuthClient();

  const handleClick = () => {
    try {
      client?.requestCode();
    } catch (error) {
      displayErrorToast({ error });
    }
  };

  return (
    <button disabled={disabled} onClick={handleClick} className={className}>
      {children}
    </button>
  );
};

export default GoogleAuthButton;
